<div *ngIf="errors.length" class="form-error-summary" role="alert">
  <div class="form-error-summary__header">
    <i class="fa fa-exclamation-triangle"></i>
    {{ errors.length === 1 ? '1 field needs your attention:' : errors.length + ' fields need your attention:' }}
  </div>
  <ul class="form-error-summary__list">
    <li *ngFor="let error of errors">
      <button type="button" class="form-error-summary__link" (click)="onClick(error.key)">
        {{ error.label }}
      </button>
    </li>
  </ul>
</div>
